import { Component, Input } from '@angular/core';

import { Option } from 'shared/form/select/option.interface';

import { BaseConfigureExportModalComponent } from '../_base-configure-export-modal.component';
import { Product } from '../../../../my-products.interface';


@Component({
  moduleId: module.id,
  selector: 'configure-working-export-modal',
  templateUrl: '../configure-export-modal.component.html',
  styleUrls: [
    '../configure-export-modal.component.scss',
    'configure-working-export-modal.component.scss'
  ],
})
export class ConfigureWorkingExportModalComponent extends BaseConfigureExportModalComponent {
  status: string = 'working';
  hasExportTypes: boolean = true;

  @Input() products: Array<Product> = [];
}
